export enum StoreType {
  'fisica'= 'fisica',
  'online'= 'online',
  'fuerza_ventas'= 'fuerza_ventas',
}
